var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$can('read','marketing'))?_c('router-link',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-sm",attrs:{"to":_vm.row.hashid+'/actions'}},[_c('i',{staticClass:"fa fa-eye"})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }